import React from 'react';
import { Select } from 'antd';
import { ModeOption } from 'antd/lib/select';

export interface IOption {
	key: string;
	label: string;
}

interface IProps {
	placeholder?: string;
	value?: any;
	options?: IOption[];
	onChange?: (value: {}) => void;
	name?: string;
	id?: string;
	mode?: ModeOption;
	required?: boolean;
	className?: string;
	disabled?: boolean;
}

const Dropdown: React.FC<IProps> = props => {
	return (
		<Select
			labelInValue={true}
			onChange={props.onChange}
			value={props.value!}
			id={props.name}
			mode={props.mode!}
			disabled={props.disabled!}
			placeholder={props.placeholder}
		>
			{
				props.options !== undefined ? props.options.map(opt => {
					return <Select.Option
						key={opt.key}
						value={opt.key}
					>
						{opt.label}
					</Select.Option>;
				}) : []
			}
		</Select>
	);
};

export default Dropdown;